
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/p/[category]",
      function () {
        return require("private-next-pages/p/[category]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/p/[category]"])
      });
    }
  